import React, { useEffect } from "react";
import { HomeCarousel, HomeMobileCarousel, HomeCategories, CarouselProducts, HalfCarouselProducts, TopPicks, BrandOfTheWeek } from "../components/homepage";
import { HomeBannerPlaceholder } from "../components/Common/Placeholders";
import { CarouselProducts as CarouselProductsplaceholder, HalfCarouselProducts as HalfCarouselProductsplaceholder } from "../components/placeholders";
import { Container } from "react-bootstrap";
import { MediaQueries } from "../components/utils";
import { useSelector } from "react-redux";
import { ComponentHeader } from "../components/Common";
import { Row, Col } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { getcategory_items } from "../redux/homeslice";
import { useDispatch } from "react-redux";
import { pushToDataLayer } from "../components/utils/dataUserpush"
const Home = () => {
    const bannerList = useSelector(state => state.homeslice.bannerList);
    const loading = useSelector(state => state.homeslice.loading);
    const loading6 = useSelector(state => state.homeslice.loading6);
    const loading8 = useSelector(state => state.homeslice.loading8);
    const loading9 = useSelector(state => state.homeslice.loading9);
    const home_category_items = useSelector(state => state.homeslice.home_category_items);
    const bundle_clearance_sale = useSelector(state => state.homeslice.bundle_clearance_sale);
    const deals_offers = useSelector(state => state.homeslice.deals_offers);
    const DealOfTheDay = useSelector(state => state.homeslice.DealOfTheDay);
    const saver_zone = useSelector(state => state.homeslice.saver_zone);
    const TopSelling = useSelector(state => state.homeslice.TopSelling);
    const top_picks = useSelector(state => state.homeslice.top_picks);
    const brand_week = useSelector(state => state.homeslice.brand_week);
    const deals_loading = useSelector(state => state.homeslice.loading1);
    const loading5 = useSelector(state => state.homeslice.loading5);
    const saver_zone_loading = useSelector(state => state.homeslice.loading3);
    const TopSelling_loading = useSelector(state => state.homeslice.loading4);
    const DealOfTheDay_loading = useSelector(state => state.homeslice.loading2);
    const categoryList = useSelector(state => state.globalslice.data);
    const categoryloading = useSelector(state => state.globalslice.loading);
    const currentcountry = useSelector((state) => state.globalslice.currentcountry);

    const dispatch = useDispatch()

    const { isMobile } = MediaQueries()

    useEffect(() => {
        dispatch(getcategory_items())
    }, [])

    useEffect(() => {
        pushToDataLayer("viewed_home_page", currentcountry.name);
    }, []);
    return (
        <>
            {
                !loading ? (isMobile ?
                    <Container fluid className="pt-2">
                        <HomeMobileCarousel carousel_data={bannerList.carousel} />
                    </Container>
                    :
                    <HomeCarousel carousel_data={bannerList.carousel} />
                ) : <HomeBannerPlaceholder height={424} />
            }
            <Container fluid >
                <div className={isMobile ? 'mt-2' : "mt-5"}></div>
                <HomeCategories category_list={categoryList} type={1} />

                <div className={isMobile ? 'mt-3' : "mt-4"}></div>
                <div className="component_1">
                    <ComponentHeader title={'Exciting Offers'} view_all={'rgba(82, 50, 194, 1)'} />
                    {
                        deals_loading ?
                            <CarouselProductsplaceholder category_list={[1, 2, 3, 4, 5, 6, 7, 8]} type={1} />
                            :
                            <CarouselProducts products={deals_offers.exciting_offers} type={1} inner_bg={'rgba(238, 235, 250, 1)'} />
                    }
                </div>

                <div className={isMobile ? 'mt-3' : "mt-4"}></div>

                <NavLink className="single_banner" to={currentcountry?.nav_items.find(({ status }) => status == 0).url}>
                    <img src={'assets/banners/banner_1.png'} />
                </NavLink>

                <div className={isMobile ? 'mt-3' : "mt-4"}></div>

                <Row className='half_carousel_products'>
                    <Col lg={6} className={`padding_custom ${isMobile && 'mb-3'}`}>
                        {
                            DealOfTheDay_loading ?
                                <HalfCarouselProductsplaceholder category_list={[1, 2, 3, 4, 5, 6, 7, 8]} type={2} />
                                :
                                <HalfCarouselProducts title={'Deal Of The Day'} first_title={'DEAL OF THE'} second_title={'DAY'} url={'/deals-of-the-day'} products={DealOfTheDay} type={2} bg_color={'#EEEBFA'} inner_bg={'rgba(238, 235, 250, 1)'} first_string_color={'#fff'} second_string_color={'rgba(255, 207, 10, 1)'} view_all={'#fff'} />
                        }
                    </Col>
                    <Col lg={6}>
                        {
                            saver_zone_loading ?
                                <HalfCarouselProductsplaceholder category_list={[1, 2, 3, 4, 5, 6, 7, 8]} type={2} />
                                :
                                <HalfCarouselProducts first_title={'SAVER'} second_title={'ZONE'} url={'/saver-zone'} products={saver_zone} type={2} title={'Saver Zone'} inner_bg={'rgba(255, 250, 229, 1)'} bg_color={'#FFFAE5'} first_string_color={'#000'} second_string_color={'rgba(82, 50, 194, 1)'} view_all={'rgba(82, 50, 194, 1)'} />

                        }     </Col>
                </Row>

                <div className={isMobile ? 'mt-3' : "mt-4"}></div>

                <NavLink className={`single_banner`} to={'/brands/ruky'}>
                    <img src={'assets/banners/banner_2.webp'} />
                </NavLink>

                <div className={isMobile ? 'mt-3' : "mt-4"}></div>

                <Row className="multi_banners">
                    {
                        !loading &&
                        <>
                            {
                                bannerList.multibanners.map((banner) => {
                                    return (
                                        <Col lg={6} key={banner.banner_id} className="padding_custom">
                                            <NavLink to={banner.url}>
                                                <img src={banner.banner_image} />
                                            </NavLink>
                                        </Col>
                                    )
                                })
                            }
                        </>
                    }
                </Row>

                <Row className={`multi_banners_four ${!isMobile && 'mt-0'}`}>
                    {
                        !loading &&
                        <>
                            {
                                bannerList.banner.map((banner) => {
                                    return (
                                        <Col lg={3} md={3} key={banner.banner_id} sm={6} xs={6} className="pr-unset">
                                            <NavLink to={banner.url}>
                                                <img src={banner.banner_image} />
                                            </NavLink>
                                        </Col>
                                    )
                                })
                            }
                        </>
                    }
                </Row>

                {
                    currentcountry?.isTabbyRequired &&
                    <>
                        <div className={isMobile ? 'mt-3' : "mt-4"}></div>

                        <div className={`single_banner `}>
                            <img src={'assets/banners/banner_3.webp'} />
                        </div>
                    </>
                }


                <div className={isMobile ? 'mt-3' : "mt-4"}></div>
                <div className="component_1">
                    <ComponentHeader title={'Top Selling'} url={'/deals/Top-Selling-Products'} view_all={'rgba(82, 50, 194, 1)'} />
                    {
                        TopSelling_loading ?
                            <CarouselProductsplaceholder category_list={[1, 2, 3, 4, 5, 6, 7, 8]} type={1} />
                            :
                            <CarouselProducts products={TopSelling} type={1} inner_bg={'rgba(238, 235, 250, 1)'} type2={1} />
                    }
                </div>

                <div className={isMobile ? 'mt-3' : "mt-4"}></div>

                <div className="component_1">
                    <ComponentHeader title={'Bundle Deals'} url={'/bundle-deals'} view_all={'rgba(82, 50, 194, 1)'} />
                    {
                        loading9 ?
                            <CarouselProductsplaceholder category_list={[1, 2, 3, 4, 5, 6, 7, 8]} />
                            :
                            <CarouselProducts products={bundle_clearance_sale.bundle_deals} type={1} inner_bg={'rgba(238, 235, 250, 1)'} />
                    }
                </div>

                <div className={isMobile ? 'mt-3' : "mt-4"}></div>


                <NavLink className={`single_banner`} to={'/categories/Health-Beauty'}>
                    <img src={'assets/banners/banner_4.webp'} />
                </NavLink>

                <div className={isMobile ? 'mt-3' : "mt-4"}></div>

                <div className="component_1">
                    <ComponentHeader title={'Top Picks From Popular Brands'} view_all={'rgba(82, 50, 194, 1)'} />
                    <div className="carousel_products" style={{ background: !isMobile && 'rgba(238, 235, 250, 1)' }}>
                        {
                            !loading5 &&
                            <TopPicks carousel_data={top_picks} />
                        }
                    </div>
                </div>
                <div className={isMobile ? "mt-3" : 'mt-5'}></div>

                {
                    !loading8 &&
                    <div className="half_carousel_products">
                        <BrandOfTheWeek title={'Brand of the Week'} data={brand_week[0]} url={`/brands/${brand_week[0].sku}`} products={brand_week[0].items} type={1} bg_color={'#EEEBFA'} inner_bg={'rgba(238, 235, 250, 1)'} view_all={'#fff'} />
                    </div>
                }

                <div className={isMobile ? 'mt-3' : "mt-4"}></div>
                <NavLink className={`single_banner`} to={'/clearance'}>
                    <img src={'assets/banners/banner_5.webp'} />
                </NavLink>
                <div className={isMobile ? 'mt-3' : "mt-4"}></div>
                {
                    !categoryloading &&
                    <div className="component_1">
                        <ComponentHeader title={'Shop By Categories'} view_all={'rgba(82, 50, 194, 1)'} />

                        <Row className="mb-2 mx-0">
                            {
                                categoryList.map((item) => {
                                    return (
                                        <Col lg={3} md={6} className="mb-3">
                                            <NavLink to={`/categories/${item.url}`} className={'text-decoration-none'}>
                                                <div className="home_card_2" to={`/categories/${item.url}`}>
                                                    <div className="home_card_bg_image">
                                                        <img src={item.vector_icon} />
                                                    </div>
                                                    <div className="home_card_2_title text-center">{item.category_name}</div>
                                                </div>
                                            </NavLink>

                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </div>
                }

                {
                    !loading6 &&
                    <>
                        {
                            home_category_items.map((section) => {
                                return (
                                    <div className="component_1 mt-4">
                                        <ComponentHeader title={section.subcategory_name} url={`/products-category/${section.url}`} view_all={'rgba(82, 50, 194, 1)'} />
                                        <CarouselProducts products={section.items} type={1} inner_bg={'rgba(238, 235, 250, 1)'} />
                                    </div>
                                )
                            })
                        }
                    </>
                }
            </Container>
        </>

    )
}
export default Home;